import { Box, Typography } from "@mui/material";

interface Props {
  /** Body copy — the stage's own explanation of why it does not apply */
  text?: string | React.ReactNode;
}

/**
 * Calm, header-less notice used when fraud correction never touched this field.
 */
const FraudNotApplicableNotice = ({ text }: Props) => (
  <Box
    sx={{
      border: "1px solid #E0E0E0",
      borderRadius: "8px",
      backgroundColor: "#FAFAFA",
      p: 1.5,
    }}
  >
    <Typography
      sx={{
        color: "#00000099",
        fontSize: "14px",
        lineHeight: "20px",
      }}
    >
      {text}
    </Typography>
  </Box>
);

export default FraudNotApplicableNotice;
